/* ============================================================
   OS9 STICKY NOTE — Stickies-style note for announcements
   squiche.com

   A Stickies note is deliberately NOT an os9-win. It has no title bar, no
   zoom or collapse box, no scroll bars and no info bar — just a coloured
   sheet with a hairline border, a small close box in the top-right corner
   and fold marks in the other three. Building it out of the window chrome
   would mean removing more than it kept.

   Content and behaviour come from `sticky_note` blocks in the theme editor
   via OS9Config.stickyNotes, so copy changes never need a code change.
   ============================================================ */

(function () {
  'use strict';

  /* Stickies' own palette. Deliberately outside the OS9 neutral ramp — these
     are coloured paper, not chrome, the same exemption the Geocities page and
     the Game Boy screen already have. */
  var PAPER = {
    green:  { bg: '#ccffcc', edge: '#66cc66' },
    yellow: { bg: '#ffffcc', edge: '#cccc66' },
    pink:   { bg: '#ffcccc', edge: '#cc8888' },
    blue:   { bg: '#ccddff', edge: '#7799cc' },
  };

  var CSS = [
    '.os9-sticky{position:absolute;display:flex;flex-direction:column;',
      'border:1px solid var(--os9-black);',
      'box-shadow:var(--os9-shadow-win-bg);',
      'font-family:var(--os9-font-body);font-size:var(--os9-size-ui);',
      'color:var(--os9-black);cursor:default;user-select:none;}',

    /* The four corner marks. Only the top-right one does anything; the other
       three are the fold marks Stickies draws, which is what makes the sheet
       read as paper rather than as a plain box. */
    '.os9-sticky__corner{position:absolute;width:9px;height:9px;}',
    '.os9-sticky__corner--tr{top:2px;right:2px;border-top:1px solid;border-right:1px solid;}',
    '.os9-sticky__corner--bl{bottom:2px;left:2px;border-bottom:1px solid;border-left:1px solid;}',
    '.os9-sticky__corner--br{bottom:2px;right:2px;border-bottom:1px solid;border-right:1px solid;}',

    /* Close box top-LEFT, where every Mac window puts it. Drawn as a filled
       box rather than a bare fold mark so it reads as a control and not as
       the three decorative corners it sits alongside. */
    '.os9-sticky__close{position:absolute;top:2px;left:2px;width:11px;height:11px;',
      'border:1px solid;background:rgba(255,255,255,0.5);cursor:default;z-index:2;}',
    '.os9-sticky__close:active{background:rgba(0,0,0,0.18);}',
    /* Generous invisible hit area — the visible mark is 9px, which is a hard
       target on a phone. */
    '.os9-sticky__close::after{content:"";position:absolute;top:-6px;right:-6px;',
      'width:22px;height:22px;}',

    '.os9-sticky__body{flex:1;padding:12px 14px;overflow:auto;line-height:1.45;}',
    '.os9-sticky__body p{margin:0 0 0.8em;}',
    '.os9-sticky__body p:last-child{margin-bottom:0;}',
    '.os9-sticky__body a{color:var(--os9-link);}',

    /* The drag surface is the whole sheet, so a note can be moved from
       anywhere on it the way Stickies works. */
    '.os9-sticky.is-dragging{opacity:0.9;}',
  ].join('');

  var cssInjected = false;
  function injectCSS() {
    if (cssInjected) return;
    cssInjected = true;
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function layer() {
    return document.getElementById('os9-desktop-area') || document.body;
  }

  /* Notes sit above every window. os9-windows.js starts its stack at 1100 and
     raises _os9TopZ as windows are focused, so read that rather than picking a
     number that a few window activations would overtake. */
  function topZ() {
    return Math.max(window._os9TopZ || 1100, 1100) + 50;
  }

  function makeDraggable(el) {
    var startX, startY, originX, originY, dragging = false;

    function down(e) {
      if (e.target.closest('.os9-sticky__close')) return;
      var p = e.touches ? e.touches[0] : e;
      dragging = true;
      startX = p.clientX; startY = p.clientY;
      originX = parseFloat(el.style.left) || 0;
      originY = parseFloat(el.style.top) || 0;
      el.classList.add('is-dragging');
      el.style.zIndex = topZ();
      e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      var p = e.touches ? e.touches[0] : e;
      var host = layer();
      var maxX = Math.max(0, host.offsetWidth  - el.offsetWidth);
      var maxY = Math.max(0, host.offsetHeight - el.offsetHeight);
      el.style.left = Math.min(maxX, Math.max(0, originX + (p.clientX - startX))) + 'px';
      el.style.top  = Math.min(maxY, Math.max(0, originY + (p.clientY - startY))) + 'px';
      e.preventDefault();
    }
    function up() { dragging = false; el.classList.remove('is-dragging'); }

    el.addEventListener('mousedown', down);
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
    el.addEventListener('touchstart', down, { passive: false });
    document.addEventListener('touchmove', move, { passive: false });
    document.addEventListener('touchend', up);
  }

  function open(note) {
    injectCSS();
    var id = 'os9-sticky-' + note.id;
    var existing = document.getElementById(id);
    if (existing) { existing.style.zIndex = topZ(); return existing; }

    var paper = PAPER[note.colour] || PAPER.green;
    var host  = layer();
    var w = Math.min(note.w || 300, Math.max(160, host.offsetWidth  - 24));
    var h = Math.min(note.h || 200, Math.max(120, host.offsetHeight - 24));

    var el = document.createElement('div');
    el.className = 'os9-sticky';
    el.id = id;
    el.style.cssText =
      'width:' + w + 'px;height:' + h + 'px;' +
      'left:' + Math.max(12, Math.round((host.offsetWidth - w) / 2)) + 'px;' +
      'top:'  + Math.max(12, Math.round(host.offsetHeight * 0.16)) + 'px;' +
      'background:' + paper.bg + ';z-index:' + topZ() + ';';

    el.innerHTML =
      '<div class="os9-sticky__close" role="button" tabindex="0" aria-label="Close note" ' +
        'style="border-color:' + paper.edge + '"></div>' +
      '<div class="os9-sticky__corner os9-sticky__corner--tr" style="border-color:' + paper.edge + '"></div>' +
      '<div class="os9-sticky__corner os9-sticky__corner--bl" style="border-color:' + paper.edge + '"></div>' +
      '<div class="os9-sticky__corner os9-sticky__corner--br" style="border-color:' + paper.edge + '"></div>' +
      '<div class="os9-sticky__body">' + (note.body || '') + '</div>';

    host.appendChild(el);

    var closeBtn = el.querySelector('.os9-sticky__close');
    function close() { el.remove(); }
    closeBtn.addEventListener('click', close);
    closeBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(); }
    });

    el.addEventListener('mousedown', function () { el.style.zIndex = topZ(); });
    makeDraggable(el);
    return el;
  }

  function notes() {
    return (window.OS9Config && window.OS9Config.stickyNotes) || [];
  }

  function openAll() { notes().forEach(open); }

  function autoOpen() {
    notes().forEach(function (n) { if (n.autoOpen) open(n); });
  }

  window.OS9Sticky = { open: open, openAll: openAll, autoOpen: autoOpen, notes: notes };

  /* Opened after the desktop's own auto-open pass (600ms in squiche-os.js) so
     that notes land on top of any window that opens itself on load — the
     browser behind the Finder, the Finder behind the note. */
  function start() { setTimeout(autoOpen, 1100); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
